var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('header-block'),_c('banner-block'),_c('advantages-block'),_c('benefit-block'),_c('use-block'),_c('footer-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }